import { createSelector } from "reselect";
import { sameGuid } from "contexts/orgFilter";

// Basic selectors
const selectSites = (state) => state.sites?.byId || {};

export const getAllSites = createSelector(
  [selectSites],
  (sites) => {
    return Object.values(sites);
  }
);

export const getSitesByOrganizationGuid = (organizationGuid) =>
  createSelector(
    [selectSites],
    (sites) => {
      return Object.values(sites).filter(
        site => sameGuid(site.customer?.customerGuid, organizationGuid)
      );
    }
  );

export const getSiteSettingsByGuid = (siteGuid) =>
  createSelector(
    [selectSites],
    (sites) => {
      const site = sites[siteGuid];
      return site ? site.settings : null;
    }
  );